export interface INavLink {
  title: string;
  to: string;
  /** ícones da tab bar do app (ativo/inativo) */
  icon?: { active: string; inactive: string };
  navigate?: () => void;
}

// Links compartilhados entre Navbar (desktop) e Sidebar (mobile)
/** Ícones da tab bar do app (assets/img/tab_icons, copiados do psiapp-reactnative-user). */
export const tabIcon = (name: string) => ({
  active: require(`@/assets/img/tab_icons/${name}_active.png`),
  inactive: require(`@/assets/img/tab_icons/${name}_inactive.png`),
});

/**
 * Link ativo também nas subtelas (/mais/blog, /mais/pagamento acendem o "Mais").
 * O ativo do router-link compara o registro da rota, e /mais/blog é outra rota.
 */
export const isNavLinkActive = (currentPath: string, to: string) =>
  currentPath === to || currentPath.startsWith(`${to}/`);

// Como as abas do app: Home, Sessões, Chats e Mais (o Blog fica dentro do "Mais")
export const getNavLinks = (paths: any): INavLink[] => [
  { to: paths.home, title: "Home", icon: tabIcon("home") },
  { to: paths.appointments.list, title: "Sessões", icon: tabIcon("appointments") },
  { to: paths.chats, title: "Chats", icon: tabIcon("chat") },
  { to: paths.more, title: "Mais", icon: tabIcon("more") },
];
